import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	flex-flow: column nowrap;
	align-items: center;
	justify-content: center;
	height: 850px;
	position: relative;
	overflow: hidden;
	@media screen and (max-width: 900px) {
		height: auto;
		padding: 50px 0;
	}
`;

export const VideoContainer = styled.div`
	position: absolute;
	z-index: -1;
	top: 0;
	overflow: hidden;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	video {
		width: 100%;
		height: 100%;
		object-fit: cover;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 9;
	}
`;

export const FontContainer = styled.div`
	width: 60%;
	@media screen and (max-width: 1100px) {
		width: 100%;
		text-align: center;
	}
`;

export const Link = styled.a`
	margin: 16px 0;
	color: #fff;
	font-size: 18px;
	line-height: 0.5;
	font-weight: 600;
	@media screen and (max-width: 700px) {
		line-height: 1.2;
		width: 95%;
		font-size: 14px;
	}
	@media screen and (max-width: 400px) {
		font-size: 13px;
	}
`;

export const FontSmall = styled.p`
	margin: 16px;
	color: #fff;
	font-size: 16px;
	line-height: 0.5;
	text-align: center;
	font-family: Montserrant;
	strong {
		font-family: Montserrant-Black;
	}
	@media screen and (max-width: 700px) {
		line-height: 1.2;
		width: 95%;
		font-size: 14px;
	}
	@media screen and (max-width: 400px) {
		font-size: 13px;
	}
`;

export const FontMedium = styled.p`
	margin: 14px;
	color: #fff;
	font-size: 20px;
	line-height: 1;
	font-weight: 800;
	text-align: center;
	font-family: Montserrant-Bold;
	@media screen and (max-width: 500px) {
		font-size: 22px;
	}
	@media screen and (max-width: 400px) {
		font-size: 20px;
	}
`;

export const FontBig = styled.p`
	margin: 8px 0;
	color: #fff;
	font-size: 36px;
	line-height: 1;
	font-weight: 900;
	text-align: center;
	font-family: Montserrant-Black;
	@media screen and (max-width: 500px) {
		font-size: 38px;
	}
	@media screen and (max-width: 400px) {
		font-size: 34px;
	}
`;

export const Line = styled.div<{ width: string }>`
	width: ${({ width }) => width};
	height: 1px;
	background-color: #fff;
	margin: 0 auto;
`;

export const BannerDecorsContainer = styled.div`
	width: 100%;
	margin: 0 auto;
	margin-top: 60px;
	display: flex;
	align-items: center;
	justify-content: center;
	@media screen and (max-width: 900px) {
		flex-flow: column nowrap;
	}
`;

export const DecorContainer = styled.div`
	width: 250px;
	min-width: 250px;
	height: 250px;
	position: relative;
	user-select: none;
	pointer-events: none;
	margin: 0 20px;
	@media screen and (max-width: 900px) {
		&:nth-child(2) {
			margin: 40px 0;
		}
	}
`;

export const DecorImage = styled.img`
	width: 100%;
	height: 100%;
`;

export const DecorImageContent = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	color: #fff;
	font-family: Montserrant-Bold;
	text-align: center;
	p {
		height: 40px;
		font-size: 16px;
	}
	svg {
		fill: #fff;
		width: 60px;
		height: 60px;
	}
`;
